import React from "react";
import { MapPin, FileText } from "lucide-react";
import { motion } from "framer-motion";

const LookupMethodSelector = ({ lookupBy, setLookupBy, isLoading }) => {
    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center justify-between">
                <label className="text-sm font-bold text-slate-800 uppercase tracking-widest">
                    Lookup Method
                </label>
                <div className="h-[1px] flex-1 mx-4 bg-slate-100" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <button
                    onClick={() => setLookupBy("address")}
                    disabled={isLoading}
                    className={`group relative overflow-hidden px-4 py-3 rounded-xl font-bold transition-all duration-300 flex items-center gap-3 ${lookupBy === "address"
                        ? "bg-blue-600 text-white shadow-lg shadow-blue-500/10"
                        : "bg-slate-50 text-slate-600 hover:bg-slate-100"
                        } ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                    <div className={`p-1.5 rounded-lg transition-colors ${lookupBy === "address" ? "bg-white/20" : "bg-white border border-slate-200"}`}>
                        <MapPin className="w-4 h-4" />
                    </div>
                    <div className="text-left">
                        <span className="block text-sm">Address</span>
                    </div>
                    {lookupBy === "address" && (
                        <motion.div
                            layoutId="lookupActive"
                            className="absolute right-3 w-1 h-1 bg-white rounded-full"
                        />
                    )}
                </button>
                <button
                    onClick={() => setLookupBy("apn")}
                    disabled={isLoading}
                    className={`group relative overflow-hidden px-4 py-3 rounded-xl font-bold transition-all duration-300 flex items-center gap-3 ${lookupBy === "apn"
                        ? "bg-blue-600 text-white shadow-lg shadow-blue-500/10"
                        : "bg-slate-50 text-slate-600 hover:bg-slate-100"
                        } ${isLoading ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                    <div className={`p-1.5 rounded-lg transition-colors ${lookupBy === "apn" ? "bg-white/20" : "bg-white border border-slate-200"}`}>
                        <FileText className="w-4 h-4" />
                    </div>
                    <div className="text-left">
                        <span className="block text-sm">APN</span>
                    </div>
                    {lookupBy === "apn" && (
                        <motion.div
                            layoutId="lookupActive"
                            className="absolute right-3 w-1 h-1 bg-white rounded-full"
                        />
                    )}
                </button>
            </div>
        </div>
    );
};

export default LookupMethodSelector;
